import { useConfigContext } from "@/contexts/config-context";
import { createPortal } from "react-dom";
//@ts-expect-error
import terminal from 'virtual:terminal';

import styles from './styles.module.scss'

export function ModalVelocityConfig() {
  const { changeAnimationVelocity, animationVelocity, isOpenModalConfigTimingAnimation, handleCloseModalConfigTimingAnimation } = useConfigContext()

  if (!isOpenModalConfigTimingAnimation) return null
  terminal.log(animationVelocity)
  return createPortal(
    <div className={styles.layer} onClick={handleCloseModalConfigTimingAnimation}>
      <div onClick={e => e.stopPropagation()}>
        <button onClick={handleCloseModalConfigTimingAnimation}>
          <img
            src="/assets/btn_close.png"
          />
        </button>
        <header>
          <img
            src="/assets/config-icon.svg"
            alt="Icone de configuração"
          />

          <h3>Configuração</h3>
        </header>

        <div>
          <b>Velocidade</b>

          <ul>
            <li>
              <button
                className={`${animationVelocity === "x1" ? styles.active : ''}`}
                onClick={() => {
                  changeAnimationVelocity("x1")
                }}
              >
                1x
              </button>
            </li>
            <li

            >
              <button
                className={`${animationVelocity === "x2" ? styles.active : ''}`}
                onClick={() => {
                  changeAnimationVelocity("x2")
                }}
              >
                2x
              </button>
            </li>
            <li

            >
              <button
                className={`${animationVelocity === "x3" ? styles.active : ''}`}
                onClick={() => {
                  changeAnimationVelocity("x3")
                }}
              >
                3x
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>,
    document.body
  )
}